import { AnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import AnscNotificationsShared from 'shell/components/shared/ansc-notifications/list';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <AnscNotificationsShared
        scope={IdAmbito.Cancellazioni}
        items={AnscNotificationsCancellationsCrumbs}
      />
    </Fragment>
  );
};

AnscNotificationsPage.displayName = 'Ansc Notification page component';

export default AnscNotificationsPage;
